/**
 * Enrollment Service
 * Handles all enrollment-related API calls
 *
 * @module services/EnrollmentService
 */

import BaseService from "core/api/BaseService";

class EnrollmentService extends BaseService {
  constructor() {
    super("/enrollments");
  }

  async enroll(itemId, itemType) {
    return this.post("", { itemId, itemType });
  }

  async getMyEnrollments() {
    return this.get("my");
  }

  async checkEnrollment(itemId, itemType) {
    return this.get(`check/${itemType}/${itemId}`);
  }
}

export default new EnrollmentService();
